import React from 'react';
import './GlitchOverlay.css';

const GlitchOverlay: React.FC = () => {
  return <div className="glitch-overlay"></div>;
};

export default GlitchOverlay;
